import { type CommonTranslationKeys } from '@/types/translation';

export const getSafeSchoolNameTKey = (
  schoolName?: string,
): CommonTranslationKeys => {
  const schoolNameLowerCase = (schoolName || 'ALL')?.toLowerCase();
  return `common:school.levelShort.${schoolNameLowerCase}` as CommonTranslationKeys;
};
